import { render, staticRenderFns } from "./DetailsBoxInfo.vue?vue&type=template&id=6d8948d8&"
import script from "./DetailsBoxInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsBoxInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBoxInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports